module.exports = __webpack_public_path__ + "static/media/process-01.113ba6aa.png";